<template>

  <div class="wrapper">

    <Info
      v-show="isShowInfo" class="infobox"
    />

    <Portrait v-if="!this.$store.state.landscape" />

    <!--<agile :arrows="false" :dots="false" :infinite="true" ref="slider" class="slider-wrapper" >-->
    <flickity ref="flickity" :options="flickityOptions">

      <Slide
        class="slide"
        v-for="(slide, index) in slides"
        :index="index"
        :slide="slide"
        :slider="slider"
        :isShowInfo="isShowInfo"
        :key="index"
      />

      <Colophon
        :slider="slider" :index="slides.length"
      />

    </flickity>

    <!--</agile>-->

  </div>

</template>

<script>
import copy from '@/constants/copy'
import Slide from '@/components/Slide'
import Info from '@/components/Info'
import Colophon from '@/components/Colophon'
import Portrait from '@/components/Portrait'
import Flickity from 'vue-flickity'


export default {
  name: 'Slider',
  data() {
    return {
      flickityOptions: {
        // initialIndex: (!(this.$store.state.isMobile && this.$store.state.isChrome && this.$store.state.isContinuing) && this.$store.state.slidesComplete > 0) ? (this.$store.state.slidesComplete + 1) : 0,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
      },
      msg: 'Welcome to Your Vue.js App',
      slides: copy.slides,
      slider: '',
      isShowInfo: false,
    }
  },
  components: {
    Slide,
    Info,
    Colophon,
    Portrait,
    Flickity,
  },
  created() {
    this.$eventHub.$on('toggleInfo', this.toggleInfo)

    window.onresize = () => {
      this.$store.dispatch('setOrientation')
    }
  },

  beforeDestroy() {
    this.$eventHub.$off('toggleInfo')
  },
  mounted() {
    this.slider = this.$refs.flickity
    this.slider.on('settle', () => {
      this.$eventHub.$emit('slideSettled')
    })
    this.slider.on('select', () => {
      this.$eventHub.$emit('slideSelected')
    })
  },
  methods: {
    toggleInfo() {
      // console.log('toggle info!')
      this.isShowInfo = !this.isShowInfo
    },
  },

}
</script>


<style lang="scss" scoped>

.wrapper {
  height: 100%;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Slider.vue